import React from "react";
import { useOutletContext } from "react-router-dom";
import InstitutionComponent from "../../components/institution-component/InstitutionComponent";
import ScrollToTop from "../../components/scroll-to-top/ScrollToTop";

const MovieExplorePage: React.FC = () => {
  const { movieExplorePageContext }: any = useOutletContext();
  return (
    <>
      <ScrollToTop />
      <InstitutionComponent
        availableForFilmAndTV
        availableForEvents={undefined}
        isVirtual={false}
        context={movieExplorePageContext}
        title="AVAILABLE MOVIE AND TV LOCATIONS"
      />
    </>
  );
};

export default MovieExplorePage;
